import { render, staticRenderFns } from "./VocabularyList.vue?vue&type=template&id=987614ec&scoped=true&"
import script from "./VocabularyList.vue?vue&type=script&lang=js&"
export * from "./VocabularyList.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyList.vue?vue&type=style&index=0&id=987614ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987614ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VSpacer})
